module.exports = __webpack_public_path__ + "static/img/baseT200_logo_zurqui.88c66a65.png";